import { LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { Avatar, Box, Button, CardContent, CardHeader, CssBaseline, Grid, IconButton, InputAdornment, LinearProgress, Paper, TextField, Typography, Card } from '@mui/material';
import { Navigate, Route, Routes, useLocation, useNavigate, } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import Grid2 from '@mui/material/Grid2';
import proxelera from '../../images/proxelera.png';
import { commons } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import AuthService from '../../service/AuthService';
import background from "../../images/background.jpg"
import background1 from "../../images/background1.jpg"
import { customStyles } from "../../styles/tableStyle"

import { passwordResetForm } from '../../schema/formSchema/forgotPassword';
import { regExp } from '../../constants/regEx';
import { toast } from 'react-toastify';


function ForgotPassword(props) {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState([]);
  const [email, setEmail] = useState('')
  const [emailErr, setEmailErr] = useState(undefined)
  const [verified, setVerified] = useState(false)
  const [otp, setOtp] = useState(undefined)
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    AuthService.getUserInfo() != null ?
      navigate("/dashboard") :
      loadForm();
  }, []);

  const handleKeyDown = (event, key) => {
    if (event.key === 'Enter') {
      changePassword(event, key);
    }
  };

  const loadForm = async () => {
    let loginSchemaData = [...passwordResetForm];
    setLoginData(loginSchemaData);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value)
  }
  const changePassword = async (event) => {
    event.preventDefault();
    let loginContent = [...loginData];
    let validFormData = await validateFormData(loginContent);
    setLoginData(validFormData)
    let result = validFormData.find(item => {
      if (item.error.length) return item;
    });
    let otpData = validFormData.findIndex(item => item.key === "otp")

    if (validFormData[otpData].value != otp) {
      validFormData[otpData].error = "Invalid otp"
      setLoginData(validFormData)
      result = validFormData.find(item => {
        if (item.error.length) return item;
      });
    }
    let passwordData = validFormData.find(item => item.key === "password");
    let confirmPasswordData = validFormData.findIndex(item => item.key === "confirmPassword")
    if (passwordData.value != validFormData[confirmPasswordData].value) {
      validFormData[confirmPasswordData].error = "Invalid password"
      setLoginData(validFormData)
      result = validFormData.find(item => {
        if (item.error.length) return item;
      });
    }

    if (!result) {
      setLoading(true)
      let params = await formToObj(validFormData);
      params.op = "setPassword"
      delete params.confirmPassword
      params.email = email
      commons.getAPIRes(params, "POST", "user").then(userRes => {
        setLoading(false)
        if (userRes.status) {
          toast.success(userRes.message)
          navigate('/login');
        }
        else {
          toast.error(userRes.message)

        }
      });
    }
    else {

    }
  };

  const renderDashBoard = () => {
    props.history.push('/ticket-list')
  };

  const redirectRegister = () => {
    navigate("/register")
  }

  const handleChange = (e, key) => {
    const newValue = e.target.value;
    setLoginData((prevData) =>
      prevData.map((item) =>
        item.key === key
          ? { ...item, value: newValue, error: '' }
          : item
      )
    );
  };

  const sendOTP = (e) => {
    let isValid = regExp.email.test(email);
    setEmailErr(!isValid)
    if(isValid){
      setLoading(true)
      let params = { "op": "verifyUser", "email": email }
      commons.getAPIRes(params, "POST", "user").then(userRes => {
        setLoading(false)
        if (userRes.status) {
          let res = userRes.result;
          setOtp(res.data)

        }
        else {
          toast.error(userRes.errCode.email[0])
        }
      });
    }
    

  }
  return (
    <Grid2 container spacing={2} sx={{
      justifyContent: "center",
      alignItems: "center",
      backgroundImage: `url(${background})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      width: '100vw',
      height: '100vh'
    }} >
      <CssBaseline />
      <Grid2 size={{ md: 2 }} />
      <Grid2 size={{ md: 3 }} >
        <Paper elevation={30}>

          <div style={{alignItems: 'center', padding: 5, margin: 5 }}>
            {/* <div style={{ flex: 1 }}>
              <Box
                component="img"
                sx={{
                  height: 233,
                  width: 350,
                  // maxHeight: { xs: 233, md: 167 },
                  // maxWidth: { xs: 350, md: 250 },
                }}
                alt="The house from the offer."
                src={proxelera}
              />
            </div> */}
            <div style={{ padding: 10 }}>
              <Box >

                {loading ? <LinearProgress sx={{ width: '100%' }} /> : false}

                <Typography variant='h5' style={{ fontWeight: 'bold', marginBottom: 20 }}>Reset Password</Typography>
                <div style={{
                  
                  alignItems: 'center'
                }}>
                  <TextField
                    sx={{ mb: 2 }}
                    type={"string"}
                    label={"Email"}
                    fullWidth
                    required
                    value={email}
                    onChange={(e) => handleEmail(e)}
                    error={emailErr}
                    helperText={emailErr ? "Valid email required" : ""}
                  />
                  <Button type="Submit"
                    color="secondary"
                    fullWidth
                    onClick={(e) => sendOTP(e)}
                    disabled={loading}
                    style={{ ...customStyles.submitBtn,  height: '30px' }}
                  >Send OTP</Button>
                </div>
                {!emailErr && otp && otp.toString().length ?

                  <span style={{ ...customStyles.successMsg, textAlign: 'left' }}
                  >OTP sent to your email id</span>
                  : false
                }

                {!emailErr && otp && otp.toString().length && loginData.map((item, index) => {
                  return (
                    <TextField
                      sx={{ mb: 1}}
                      key={index}
                      type={item.type == "password" ? (showPwd ? "text" : item.type) : item.type}
                      label={item.label}
                      fullWidth
                      required
                      value={item.value}
                      onKeyDown={(e) => handleKeyDown(e, item.key)}
                      onChange={(e) => handleChange(e, item.key)}
                      error={!!item.error}
                      helperText={item.error}
                      slotProps={{
                        endAdornment: item.type == "password" && (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowPwd(!showPwd)} >
                              {showPwd ? (<Visibility />) : (<VisibilityOff />)}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  );
                })}

                {!emailErr && otp && otp.toString().length ?
                  <Button
                    type="Submit"
                    color="secondary"
                    variant="contained"
                    fullWidth
                    onClick={changePassword}
                    disabled={loading}
                    style={{ ...customStyles.submitBtn, width: 'fit-content' }}

                  >
                    Submit
                  </Button>
                  : false}
              </Box>
            </div>
          </div>
        </Paper>

      </Grid2>
      <Grid2 size={{ md: 2 }} />

    </Grid2 >
  );
}

export default ForgotPassword;
